import BaseDataStore from '@/components/base/store/BaseDataStoreV1'
const BaseConst = {
  version: 1,
  storeName: 'ProjectPartnerList',
  serviceName: 'C3101ProjectPartnerRequirementApplicationService',
  componentDef: {
    table: {
      viewDef: [
        { text: '用戶名字', value: 'm0001_name' },
        {
          text: '合作類型',
          value: 'c3001_type',
          type: 'chip',
          // 'ADVISOR','CO_FOUNDER','MANUFACTURER','EMPLOYEE','VENDOR','PARTNER','OTHER'
          items: [
            { value: 'ADVISOR', label: '顧問', color: 'grey' },
            { value: 'CO_FOUNDER', label: '共同創辦人', color: 'grey' },
            { value: 'MANUFACTURER', label: '製造商', color: 'grey' },
            { value: 'EMPLOYEE', label: '員工', color: 'grey' },
            { value: 'VENDOR', label: '供應商', color: 'grey' },
            { value: 'PARTNER', label: '合作夥伴', color: 'grey' },
            { value: 'OTHER', label: '其他', color: 'grey' }
          ]
        },
        {
          text: '狀態',
          value: 'c3101_status',
          type: 'chip',
          // 'PENDING','IN_PROGRESS','DEAL','ACTIVE','INACTIVE','REJECTED','CLOSED','DELETED','REMOVED'
          items: [
            { value: 'PENDING', label: '待處理', color: 'grey' },
            { value: 'IN_PROGRESS', label: '處理中', color: 'grey' },
            { value: 'DEAL', label: '成交', color: 'grey' },
            { value: 'ACTIVE', label: '激活', color: 'grey' },
            { value: 'INACTIVE', label: '未激活', color: 'grey' },
            { value: 'REJECTED', label: '拒絕', color: 'grey' },
            { value: 'CLOSED', label: '關閉', color: 'grey' },
            { value: 'DELETED', label: '刪除', color: 'grey' },
            { value: 'REMOVED', label: '移除', color: 'grey' }
          ]
        },
        { text: '创建日期', value: 'c3101_created_at', type: 'date' },
        { text: '', value: 'actions' }
      ],
      optionDef: {}
    }
  }
}
const C1001Const = new BaseDataStore(BaseConst)
export default C1001Const
